@if(isMobile()){
<div class="mobile-nav-bottom">
  <button class="btn-action" routerLinkActive="active-link" routerLink="/shop">
    <span class="btn-action__icon material-symbols-outlined">savings</span>
    <span class="btn-action__text">Products</span>
  </button>
  <button class="btn-action" routerLinkActive="active-link"
    [routerLink]="signalsStoreService.hasSession() ? '/favorites' : '/login'"
    (click)="rememberRouteIfNoSession('/favorites')">
    <span class="btn-action__icon material-symbols-outlined">favorite</span>
    <span class="btn-action__text">Favorites</span>
  </button>
  <button class="btn-action" routerLinkActive="active-link"
    [routerLink]="signalsStoreService.hasSession() ? '/buy-again' : '/login'"
    (click)="rememberRouteIfNoSession('/buy-again')">
    <span class="btn-action__icon material-symbols-outlined">verified</span>
    <span class="btn-action__text">Buy again</span>
  </button>
  <button class="btn-action" routerLinkActive="active-link"
    [routerLink]="signalsStoreService.hasSession() ? returnLink() : '/login'"
    (click)="rememberRouteIfNoSession(returnLink())">
    <span class="btn-action__icon material-symbols-outlined">shopping_cart</span>

    <span class="btn-action__text">Cart</span>
    @if (orderProductsQuantity()) {
    <span class="quanity-badge">
      {{ orderProductsQuantity() }}
    </span>
    }
  </button>
</div>
}